import Navbar from "../components/lib/Navbar";
import FAQ from "../components/lib/FAQ";
import Footer from "../components/lib/Footer";
import HeroSection from "../components/landing-page/users/HeroSection";
import Driver from "../components/landing-page/agent/Driver";
import Loader from "../components/lib/Loader";

const Users = () => {
  return (
    <div>
      <div>
        <Loader />
      </div>
      <div>
        <Navbar />
      </div>
      <div>
        <HeroSection />
      </div>
      <div>
        <div className="my-10">
          <h1 className="head-text">Get started easily</h1>
          <Driver />
        </div>
      </div>

      <div className="my-24">
        <FAQ />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Users;
